<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oOhnjS/tc-custom/9781399007337.jpg?1716663163585" alt="This image is the cover for the book Hitler's Traitors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hitler's Traitors
      </h1>
      <p class="bookDescription body article font2">
        <p>This collection of vivid essays examines some of the most fascinating aspects of the German resistance to Hitler. It includes the first translations into English of pioneering studies on the role of a leading Nazi in the July Plot, the flight of Rudolf Hess to Britain and the vigorous controversy over Hugh Trevor-Roper’s investigation of Hitler’s death. The book also explores vociferous Catholic dissent in Franconia and the conspiracies against the Third Reich of the revolutionary New Beginning movement. Through the study of important personalities and dramatic events this book explores the possibilities and challenges faced by Germans in attempts to frustrate and defy Hitler’s tyranny.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward Harrison
      </h2>
      
      <p class="authorDescription body article">Edward Harrison specializes in espionage history and Nazi Germany. After Christ Church Oxford, where he obtained first class honours in history, he did postgraduate research at Munich University and as Laming Junior Fellow at The Queen's College, Oxford. He worked in Germany and taught history in universities in the US and UK. He was Visiting Professor at Detroit State University and held a Visiting Fellowship at St Antony's College, Oxford, and a Rothschild Fellowship in History from the Churchill Trust. His media experience include German TV on Trevor Roper's famous enquiry into Hitler's death. His linguistic skills equip him for extensive research and comprise German, Latin, Greek, French, Italian, Polish, Russian and Japanese. He is the author of The Young Kim Philby (2012) and editor of HughTrevor-Roper's posthumous book The Secret World (2020).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b208b5e